import { Box } from "@chakra-ui/react"
import { ReactNode } from "react"
import HomeBackIcon from "src/components/views/home/HomeBackIcon"
import { AuthPageStyling } from "src/context/types"

const DefaultFormWrap = ({
  children,
  roomStyles,
  isMobileLandscape,
  hideBackButton = true,
  top,
}: {
  children: ReactNode
  roomStyles: AuthPageStyling
  isMobileLandscape: boolean
  hideBackButton?: boolean
  top?: string
}) => (
  <>
    {!hideBackButton && (
      <div
        style={{
          width: "min-content",
          position: "absolute",
          top: "8px",
          left: 0
        }}
      >
        <HomeBackIcon
          JoinPageButtonMouseoverTextColor={
            roomStyles?.authPageButtonMouseoverTextColor
          }
          JoinPageButtonTextColor={roomStyles?.authPageButtonTextColor}
          joinButtonBackgroundColor={roomStyles?.authPageButtonBackgroundColor}
          joinButtonBorderColor={roomStyles?.authPageButtonBorderColor}
          joinButtonMouseoverBackgroundColor={
            roomStyles?.authPageButtonMouseoverBackgroundColor
          }
          navigatedFromiOS={history.length == 1}
          position="relative"
          top={"0px"}
          left={"8px"}
        />
      </div>
    )}
    <Box
      pos="relative"
      rounded={"lg"}
      bg={
        roomStyles?.authPagePanelBackgroundColor
          ? roomStyles?.authPagePanelBackgroundColor
          : "#FFFFFF"
      }
      boxShadow={"lg"}
      p={isMobileLandscape ? "16px" : 4}
      px={isMobileLandscape ? "16px" : "30px"}
      width={isMobileLandscape ? "520px" : "330px"}
      borderWidth="1px"
      borderColor={
        roomStyles?.authPagePanelBorderColor
          ? roomStyles?.authPagePanelBorderColor
          : "transparent"
      }
      top={top}
    >
      {children}
    </Box>
  </>
)

export const DefaultLandscapeFormWrap = ({
  roomStyles,
  children,
  pt,
  pb
}: {
  roomStyles: AuthPageStyling
  pt: number
  pb: number
  children: ReactNode
}) => {
  return (
    <Box
      pos="relative"
      display="flex"
      alignItems="center"
      justifyContent="center"
      bg={
        roomStyles?.authPagePanelBackgroundColor
          ? roomStyles?.authPagePanelBackgroundColor
          : "#FFFFFF"
      }
      px={"16px"}
      pt={`${pt}px`}
      pb={`${pb}px`}
      width="100%"
      height="100%"
      borderWidth="1px"
      borderColor={
        roomStyles?.authPagePanelBorderColor
          ? roomStyles?.authPagePanelBorderColor
          : "transparent"
      }
    >
      <Box w="100%" maxW="580px" mx="auto">
      {children}
      </Box>
    </Box>
  )
}


export default DefaultFormWrap
